import React from 'react';
import QRCode from '../../QRCode/QRCode';
import { useAppFeatures } from '../../../../modules/ui/selectors/app';
import { applyFilters, Filters } from '../../../../core';

const qrStyles = ['default', 'url'] as const;

type QrStyle = (typeof qrStyles)[number];

const DeviceQrCode = ({
  value,
  onClick,
}: {
  value: string;
  onClick?(): void;
}) => {
  const padding = 10;
  const features = useAppFeatures();
  const pwaAppUrl = features.pwa.url;
  const qrStyle = applyFilters<QrStyle>(Filters.assets.qr.style, 'default');
  let qrValue = value;

  switch (qrStyle) {
    case 'url':
      qrValue = `${pwaAppUrl}/${value}`;
      break;
    default:
  }

  return (
    <div style={{ margin: `-${padding}px` }}>
      <QRCode
        onClick={onClick}
        value={qrValue}
        customLabel={value}
        paddingX={padding}
        paddingY={padding}
      />
    </div>
  );
};

export default DeviceQrCode;
